import { render, staticRenderFns } from "./TeamList.vue?vue&type=template&id=3724dfbc"
import script from "./TeamList.js?vue&type=script&lang=js&external"
export * from "./TeamList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports